import React, { FunctionComponent } from 'react';
import CurrencyCell from '../../../../components/cell/CurrencyCell';

interface OwnProps {
  value: number;
}

type Props = OwnProps;

const GapCell: FunctionComponent<Props> = ({ value }) => (
  <CurrencyCell className="cell-fixed-left fixed-4" value={value} color noGreen emptyZero />
);

export default GapCell;
